export const dbFields =
{
    id: {
        visiable: false,
        title: 'Id',
        key: 'id'
    },

    name: {
        visiable: true,
        title: 'Name',
        key: 'name'
    },
    custom: {
        visiable: true,
        title: 'Custom ID',
        key: 'custom'
    },

    role:{
        visiable: true,
        title: 'Role',
        key: 'role'
    },
    parent: {
        visiable: true,
        title: 'Parent Group',
        key: 'parent_id'
    },
    createdAt: {
        visiable: true,
        title: 'Created',
        key: 'created_at'
    },
};
